// src/pages/Admin/CoursAgenda/components/CoursAgendaDrawerShell.jsx

import React, { useEffect } from "react";
import { FaTimes } from "react-icons/fa";

const CoursAgendaDrawerShell = ({
  open,
  onClose,
  title,
  subtitle,
  children,
  footer,
  widthClass = "max-w-2xl",
}) => {
  useEffect(() => {
    if (!open) return undefined;

    const previousOverflow =
      document.body.style.overflow;

    document.body.style.overflow = "hidden";

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        onClose?.();
      }
    };

    window.addEventListener(
      "keydown",
      handleKeyDown
    );

    return () => {
      document.body.style.overflow =
        previousOverflow;

      window.removeEventListener(
        "keydown",
        handleKeyDown
      );
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[100]">
      {/* Backdrop */}
      <button
        type="button"
        aria-label="Fermer"
        onClick={onClose}
        className="absolute inset-0 cursor-default bg-slate-950/55 backdrop-blur-[2px]"
      />

      {/* Drawer */}
      <aside
        className={`
          absolute right-0 top-0 flex h-full w-full flex-col
          ${widthClass}
          bg-white shadow-2xl
          dark:bg-slate-950
          border-l border-slate-200 dark:border-slate-800
        `}
      >
        {/* Header */}
        <div className="flex shrink-0 items-start justify-between gap-4 border-b border-slate-200 px-5 py-5 dark:border-slate-800 sm:px-7">
          <div className="min-w-0">
            <h2 className="text-xl font-bold text-slate-950 dark:text-white sm:text-2xl">
              {title}
            </h2>

            {subtitle && (
              <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
                {subtitle}
              </p>
            )}
          </div>

          <button
            type="button"
            onClick={onClose}
            className="
              flex h-10 w-10 shrink-0 items-center justify-center
              rounded-xl border border-slate-200
              text-slate-500 transition
              hover:bg-slate-100 hover:text-slate-950
              dark:border-slate-700
              dark:text-slate-400
              dark:hover:bg-slate-800 dark:hover:text-white
            "
          >
            <FaTimes />
          </button>
        </div>

        {/* Body */}
        <div className="min-h-0 flex-1 overflow-y-auto px-5 py-6 sm:px-7">
          {children}
        </div>

        {/* Footer */}
        {footer && (
          <div className="shrink-0 border-t border-slate-200 bg-white px-5 py-4 dark:border-slate-800 dark:bg-slate-950 sm:px-7">
            {footer}
          </div>
        )}
      </aside>
    </div>
  );
};

export default CoursAgendaDrawerShell;